import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteProcedimentoPecuarioCadastro } from '../service';
import {
    DELETE_PROCEDIMENTO_PECUARIO_CADASTRO,
  DELETE_PROCEDIMENTO_PECUARIO_CADASTRO_PENDING,
  DELETE_PROCEDIMENTO_PECUARIO_CADASTRO_SUCCESS,
  DELETE_PROCEDIMENTO_PECUARIO_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'

function* sagaDeleteProcedimentoPecuarioCadastro(action) {
  yield put({ type: DELETE_PROCEDIMENTO_PECUARIO_CADASTRO_PENDING, id: action.id })

  try {
    const a = yield call(deleteProcedimentoPecuarioCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PROCEDIMENTO_PECUARIO_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PROCEDIMENTO_PECUARIO_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteProcedimentoPecuarioCadastro() {
  yield takeLatest(DELETE_PROCEDIMENTO_PECUARIO_CADASTRO, sagaDeleteProcedimentoPecuarioCadastro)
}
